import { ProfilePageHeader } from "features/profile/ui/ProfilePageHeader"
import { ProfileTabMenu } from "features/profile/ui/ProfileTabMenu"
import { styled } from "styled-components"

export const ProfilePage = () => {
  return (
    <SContainer>
      <ProfilePageHeader />

      <ProfileTabMenu />
    </SContainer>
  )
}

const SContainer = styled.div`
  width: 800px;
  margin: auto
`